import { documentTitleFromUploadFileName, wordMimeTypeForUpload } from './upload_policy'
import { extractWordText } from './extract_word_text'
import { arrayBufferToBase64 } from './bytes_base64'

export type WordUploadPayload = {
  originalName: string
  title: string
  content: string
  mimeType: string
  /** Base64 of the original document bytes; rendered to styled HTML on-the-fly at view time. */
  blob?: string
}

export type WordUploadFailure = { originalName: string; error: string }

export async function processWordUploadFile(
  file: File,
  originalName: string,
): Promise<WordUploadPayload | WordUploadFailure> {
  let data: ArrayBuffer
  try {
    data = await file.arrayBuffer()
  } catch {
    return { originalName, error: 'read_failed' }
  }
  const extracted = await extractWordText(data)
  if (!extracted.ok) {
    return { originalName, error: extracted.error }
  }
  const title = documentTitleFromUploadFileName(originalName)
  const content = extracted.text.length === 0 ? ' ' : extracted.text
  let blob: string | undefined
  try {
    blob = arrayBufferToBase64(data)
  } catch {
    blob = undefined
  }
  return {
    originalName,
    title,
    content,
    mimeType: wordMimeTypeForUpload(originalName),
    ...(blob ? { blob } : {}),
  }
}
